import { DatePicker } from "antd";
import { useFilterDateDropdown } from "hooks/useFilterDateDropdown";
import { useListTitle } from "hooks/useListTitle";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { bankWithdrawalDeleteAction, bankWithdrawalAction } from "store/org";
import { NumberParam, useQueryParam } from "use-query-params";
import { getOrgDashboardIdField } from "utils";
import { getOrgStaffProfileOrgField } from "utils";
import { getSummationOfFields } from "utils";
import { ModifiedAntTable } from "./ModifiedAntTable";

const BankWithdrawalList = ({}) => {
  const [loading, setLoading] = useState(false);
  const [summedData, setSummedData] = useState({});
  const [deposits, setDeposits] = useState([]);
  const [filteredDeposits, setFilteredDeposits] = useState([]);
  const [page, setPage] = useQueryParam("page", NumberParam);
  const [refreshTrigger, setRefreshTrigger] = useState(false)
  const { type, id } = useParams();
  const dispatch = useDispatch();
  const [filterDate, setFilterDate] = useState();
  const {
    users: { user },
  } = useSelector((state) => ({
    users: state.users,
  }));
  const { renderFilter } = useFilterDateDropdown({ setFilterDate });
  const { fullListName } = useListTitle("withdrawals")

  useEffect(() => {
    setFilteredDeposits(deposits);
  }, [deposits]);

  useEffect(() => {
    setSummedData(
      getSummationOfFields({
        data: filteredDeposits,
        fieldsToSum: ["amount"],
      })
    );
  }, [filteredDeposits]);

  useEffect(() => {
    const userProfileOrg = getOrgStaffProfileOrgField(user.position);

    const orgIdField = getOrgDashboardIdField(type || user.position);
    let org_id = id || user[userProfileOrg]?.id;
    
    if (user.position === 'CO' && !id) {
      org_id = user.id
    }
    let queryString = `${orgIdField}=${org_id}`;

    if (filterDate) {
      queryString = queryString.concat(`&start_date=${filterDate[0].format(
        "YYYY/MM/DD"
      )}&end_date=${filterDate[1].format(
        "YYYY/MM/DD"
      )}`);
    }

    setLoading(true);
    dispatch(bankWithdrawalAction("GET", undefined, queryString))
      .then((result) => {
        setDeposits(result);
        setLoading(false);
      })
      .catch((err) => setLoading(false));
  }, [filterDate, refreshTrigger]);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this withdrawal from record?.")) {
      await dispatch(bankWithdrawalDeleteAction(id));
      setRefreshTrigger(current => !current)
    }
  };

  const tableColumn = [
    {
      title: "S/N",
      dataIndex: "id",
      render: (text, record, index) =>
        ((Number(page) || 1) - 1) * 50 + (index + 1),
      summary: "Summation",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Amount (₦)",
      dataIndex: "amount",
      render: (text, record, index) => (
        <div>{Number(record?.amount).toLocaleString()}</div>
      ),
      summary: summedData["amount"],
    },
    {
      title: "Transaction type",
      dataIndex: "withdrawal_type",
    },
    {
      title: "Cheque Numer",
      dataIndex: "cheque_number",
    },
    {
      title: "Recipient bank",
      dataIndex: "recipient_bank",
    },
    {
      title: "Recipient account name",
      dataIndex: "recipient_account_name",
    },
    {
      title: "Recipient account number",
      dataIndex: "recipient_account_number",
    },
    {
      title: "Added by",
      render: (text, record, index) =>
        `${record?.added_by?.name} (${record?.added_by?.position})`,
      summary: "-",
    },
    {
      title: "Description",
      render: (text, record) => <div>{record?.description}</div>,
      summary: "-",
    },
  ];

  if (["DR", "SM", "ZM"].includes(user?.position)) {
    tableColumn.push({
      title: "",
      dataIndex: "id",
      render: (text, record) => (
        <span role="button" onClick={() => handleDelete(record?.id)}>
          <i className="fas fa-trash"></i>
        </span>
      ),
      summary: "-",
    });
  }

  return (
    <div>
      <h3 className="page-title mb-4">{fullListName}</h3>

      <Row compact className="mb-3 filter-panel">
        <Col className="d-flex">
          {renderFilter()}
          <DatePicker.RangePicker
            style={{ width: "100%" }}
            onChange={(val) => setFilterDate(val)}
            className="mb-3"
            value={filterDate}
          />
        </Col>
      </Row>

      <ModifiedAntTable
        loading={loading}
        scroll={{ x: "max-content" }}
        columns={tableColumn}
        dataSource={filteredDeposits}
        showSummary={true}
        bordered
        pagination={{
          defaultCurrent: page,
          current: page,
          defaultPageSize: 50,
          hideOnSinglePage: true,
          onChange: (current) => setPage(current),
        }}
      />
    </div>
  );
};

export { BankWithdrawalList };
